/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, FormControl, Typography } from "@mui/material"
import FormElement from "./FormElement"
import { useEffect, useState } from "react"
import { validate } from "./FormValidation"

export type FormProps = {
  type: string
  name: string
  title: string
  label: string
  text?: string
  validation?: Array<string>
  options?: Array<{value: string|number, label: string}>
  disabled?: boolean
  isHunterElements?: boolean
  isArrivalElements?: boolean
}

type StepFormProps = {
  values: Record<string, string|number>
  forms: Array<FormProps>
  onSave: (values: Record<string, string|number>) => void
}

export const StepForm = (props: StepFormProps) => {
  const {values, forms, onSave} = props
  const [pageCount, setPageCount] = useState<number>(0)
  const [inputValues, setInputValues] = useState<Record<string, string|number>>({})
  const [error, setError] = useState<string>('')
  const [form, setForm] = useState<any>()

  useEffect(() => {
    values && setInputValues(values)
  }, [values])

  useEffect(() => {
    forms && setForm({ ...forms[pageCount]})
  }, [pageCount, forms])

  const onChange = ({name, value}) => {
    if(!name) return
    setInputValues({...inputValues, [name]: value})
  }
  const onNext = () => {
    const err = validate(inputValues[form.name], form.label, form.validation)
    if (err) {
      setError(err)
      return
    }
    setError('')
    setPageCount((pageCount) => pageCount + 1)
  }

  return form ? (
    <Box display="contents" alignItems="center" m="20px">
      <Box
        m={2}
        // height="75vh"
        display="flex"
        justifyContent="center"
        justifyItems="center"
        alignItems="center"
        mt={5}
      >
        <Box>
          <Typography variant="h5">{form.label}</Typography>
          <Typography variant="subtitle2">{form.title}</Typography>
          <Box mt={5} display="flex" justifyContent="center">
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <FormElement
                type={form.type}
                name={form.name}
                value={inputValues[form.name]}
                options={form.options}
                onChange={onChange}
                text={form.text}
                disabled={form.disabled}
                style={form.style || {}}
              />
            </FormControl>
          </Box>
          <Typography variant="body2" color="red">{error}</Typography>
          <Box mt={5} display="flex" justifyContent="center" alignItems="end">
            {pageCount !== 0 && <Button variant="outlined" onClick={() => setPageCount(pageCount - 1)}>前へ</Button>}
            {pageCount !== forms.length - 1 && <Button variant="contained" onClick={onNext}>次へ</Button>}
            {pageCount == forms.length - 1 && <Button variant="contained" onClick={() => onSave(inputValues)}>確認</Button>}
          </Box>
        </Box>
      </Box>
    </Box>
  ) : <div/>
}
